import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-experience',
  templateUrl: './main-experience.component.html',
  styleUrls: ['./main-experience.component.scss']
})
export class MainExperienceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
